var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"created"},[_c('span',{staticClass:"logoContainer"},[_c('span',{staticClass:"text"},[_vm._v("Powered by Orium")])])])}]

export { render, staticRenderFns }